import { ChangeEvent, useCallback, useEffect, useState } from 'react'

import PlainInput from 'app/common/ui-next/plain-input'
import PlainLabel from 'app/common/ui-next/plain-label'
import PlainFieldset from 'app/common/ui-next/plain-fieldset'
import { getScrollToErrorClassName } from 'app/common/hooks/useScrollToError'
import PlainHelperText from 'app/common/ui-next/plain-helper-text/plain-helper-text'

import { ControlsRow } from './templates/ControlsRow'
import { ControlsRowItem } from './templates/ControlsRowItem'


export const parentControls = {
  Name: 'parentName',
  Phone: 'phone',
  Address: 'address',
} as const

type Props = {
  loading: boolean
  disabled: boolean
  parentName: string
  parentPhone: string
  parentAddress: string
  onModified: (modified: boolean) => void
  errors: Record<string, string>
}

export const ParentControls = ({
  loading,
  disabled,
  parentName,
  parentPhone,
  parentAddress,
  onModified,
  errors,
}: Props) => {
  const [phone, setPhone] = useState(parentPhone)
  const [address, setAddress] = useState(parentAddress)

  useEffect(() => {
    if (parentPhone) setPhone(parentPhone)
  }, [parentPhone])

  useEffect(() => {
    if (parentAddress) setAddress(parentAddress)
  }, [parentAddress])

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.currentTarget
    if (name === parentControls.Phone) setPhone(value)
    if (name === parentControls.Address) setAddress(value)
    onModified(true)
  }, [onModified])

  return (
    <PlainFieldset legend="Данные родителя" strong>
      <ControlsRow>
        <ControlsRowItem width="50%">
          <PlainLabel htmlFor={parentControls.Name} displayAsBlock>{'ФИО родителя'}</PlainLabel>
          <PlainInput
            id={parentControls.Name}
            name={parentControls.Name}
            value={parentName}
            loading={loading}
            disabled
            wide
          />
        </ControlsRowItem>

        <ControlsRowItem width="50%">
          <PlainLabel htmlFor={parentControls.Phone} displayAsBlock>{'Телефон'}</PlainLabel>
          <PlainInput
            id={parentControls.Phone}
            name={parentControls.Phone}
            value={phone}
            loading={loading}
            disabled={disabled}
            onChange={handleChange}
            error={!!errors.parentPhone}
            wide
          />
          {errors.parentPhone
            && <PlainHelperText
              className={getScrollToErrorClassName()}
              error
            >
              {errors.parentPhone}
            </PlainHelperText>}
        </ControlsRowItem>
      </ControlsRow>

      <PlainLabel htmlFor={parentControls.Address} displayAsBlock>{'Адрес'}</PlainLabel>
      <PlainInput
        id={parentControls.Address}
        name={parentControls.Address}
        value={address}
        loading={loading}
        disabled={disabled}
        onChange={handleChange}
        error={!!errors.parentAddress}
        wide
      />
      {errors.parentAddress
        && <PlainHelperText
          className={getScrollToErrorClassName()}
          error
        >
          {errors.parentAddress}
        </PlainHelperText>}
    </PlainFieldset>
  )
}
